export default {
  Growth: {
    rentalTitle: "出租市场",
    rentalDesc: "向其他持有人租用票据；也可以挂出你的票据，坐收租金",
    listingCount: "在租挂单",
    avgDailyRent: "平均日租金",
    deals7d: "近 7 天成交",
    totalRent: "总租金",
    termLabel: "租期",
    dailyRent: "每日租金",
    annualized: "年化",
    rentNow: "立即租用",
    sortDaily: "按日租金",
    sortTerm: "按租期",
    sortPrice: "按总租金",
    sortNewest: "最新挂单",

    leaderboard: "战绩榜",
    leaderboardDesc: "按链上已完成结算的真实战绩排行",
    winRate: "命中率",
    bets: "场次",
    volume: "交易量",
    record: "{w}胜 · {l}负",
    winLose: "胜 / 负",
    loadMore: "加载更多",
    empty: "暂无数据",
    trader: "交易员",
    rankLabel: "排名",
    selling: "正在挂单",
    recent: "最近战绩",
    none: "暂无",
    follow: "跟单",
    modeSale: "出售",
    modeRental: "出租",
    day: "天",
    periodAll: "全部",
    period90: "90 天",
    period30: "30 天",
    period7: "7 天",
    sortRoi: "按收益率",
    sortProfit: "按盈亏",
    sortWinRate: "按命中率",
    sortVolume: "按交易量",
    sortBets: "按场次",
    referralCenter: "推广中心",
    referralRewards: "推荐奖励",
    referralRewardsDesc: "邀请好友一起参与，二级推荐奖励与 VIP 奖池实时可见",
    myMode: "我的模式",
    modeTeam: "团队模式",
    modeAgent: "代理模式",
    l1Rate: "一级返佣",
    l2Rate: "二级返佣",
    myUpline: "我的上级",
    uplineNone: "无",
    myVip: "VIP 等级",
    vipNotEnabled: "VIP 奖池未启用",
    vipNext: "下一等级",
    vipDirect: "直推",
    vipAsset: "个人资产",
    vipTeamQualified: "团队达标",
    vipPools: "可领奖池",
    tabTeam: "我的团队",
    teamLevel: "层级",
    teamMembers: "成员",
    tabCommission: "佣金明细",
    commLevel: "层级",
    commRate: "比例",
    commAmount: "金额",
    statusPending: "待结算",
    statusSettled: "已结算",
    channelOnChain: "链上已付",
    channelPlatform: "平台记账",
    communityGroup: "社区与玩法",
    referralDesc: "邀请好友、共建社区，从他们的参与中获得返佣。",
    connectFirst: "连接钱包后查看你的推广中心",
    directInvites: "直接邀请",
    totalDownline: "团队总人数",
    earned: "累计返佣",
    pendingClaim: "待提取",
    myReferrer: "我的推荐人",
    inviteLink: "我的邀请链接",
    copy: "复制",
    copied: "已复制！",
    linkHint: "好友通过此链接进入并完成链上绑定后，即计入你的邀请并产生返佣。",
    tabInvitees: "我的邀请",
    tabRewards: "返佣流水",
    tabTop: "推广榜",
    invitesCol: "邀请数",
    typeInvite: "邀请",
    typeReward: "返佣",
    typeWithdraw: "提取",
    bindTitle: "绑定上级",
    bindDesc: "绑定关系按钱包地址保存在服务端，换设备、换浏览器都不会丢失。",
    bindPlaceholder: "填写推荐人地址（0x...）",
    bindButton: "签名并绑定",
    bindFromLink: "来自邀请链接",
    bindLocked: "推荐关系只能设置一次。",
    bindSuccess: "绑定成功",
    bindFailed: "绑定失败",
    bindSelf: "不能绑定自己",
    bindCancelled: "已取消签名",
  },
  progress: "进度",
  timeLeft: "剩余 {t}",
  ended: "已结束",
  fundTitle: "资金",
  fundDesc: "查看各支持代币的合约余额、锁定金额与钱包余额",
  token: "代币",
  contractBalance: "合约余额",
  lockedAmount: "锁定中",
  unlockTime: "解锁倒计时",
  depositToContract: "存入合约",
  withdrawToWallet: "提现到钱包",
  available: "可用",
  max: "最大",
  withdraw: "提现",
  deposit: "存入",
  approve: "授权",
  withdrawTip: "提现后资金会短暂锁定，到期自动到账钱包。",
  connectWallet: "连接钱包",
  // 测试币水龙头（Claim）
  faucetEntry: "领取测试币",
  faucetTitle: "领取测试币",
  faucetDesc: "免费测试币直接进入你的合约余额，无需 gas、无需授权，领完即可下单。",
  faucetClaim: "立即领取",
  faucetClaimed: "已领取，{t} 后可再领",
  faucetClaimedBtn: "{t} 后可再领",
  faucetReady: "每 {h} 小时可领取一次。",
  faucetUnavailable: "当前网络不开放测试币领取",
  faucetSuccess: "测试币已到账（合约余额）",
  faucetFailed: "领取失败，请重试",
  faucetTip: "测试币仅用于功能测试，没有实际价值。",
  faucetTipInContract:
    "测试币直接发放到「合约余额」，不在钱包里——领完即可下单，钱包余额显示 0 是正常的。",
  fundLoading: "余额加载中…",
  // v2.1.0 多链
  selectChain: "选择网络",
  chainOnlyOneHint: "当前构建只配置了一条网络。配置并部署新链后会自动出现在这里。",
  chainSwitchFailed: "已取消切换网络",
  fundBalanceHint: "可用现金 + 持仓占用 + 提现锁定",
  fundCashHint: "合约内闲置余额，可直接下单",
  // 站内转账
  transferToUser: "站内转账",
  transferTitle: "站内转账",
  transferTo: "对方钱包地址",
  transferAddressPlaceholder: "0x...",
  transferAmount: "转账金额",
  transferSubmit: "签名并转账",
  transferTip: "站内划转：币在平台账本内转移，不发起链上交易，双方都不需要 gas。",
  transferSuccess: "转账成功",
  transferFailed: "转账失败",
  transferCancelled: "已取消签名",
  transferSelf: "不能转给自己",
  transferInsufficient: "可用余额不足",
  transferInvalidAddress: "对方地址格式不正确",
  // v2.5.0 资金风控：后台紧急开关
  riskWithdrawPaused: "提现暂时关闭，请稍后再试。",
  riskTransferPaused: "站内转账暂时关闭。",
  riskTradePaused: "交易暂时关闭。",
  // Vault（合约）侧充值/提现的前置条件提示
  vaultTokenNotAllowed: "该代币尚未在合约中开放，请联系团队处理。",
  vaultNotEnoughParticipation: "提现需要满足最低参与次数，请先参与任意盘口。",
  vaultWithdrawDisabled: "平台暂时关闭了提现，请稍后再试。",
  vaultSignatureExpired: "提现授权已过期，请重新发起。",
  withdrawPending: "你有一笔提现正在处理中，请等待完成后再操作。",
  withdrawPoolInsufficient: "合约池子流动性不足，请稍后再试。",
  insufficientBalance: "余额不足",
  // v1.9.22：钱包 RPC 限流（429）
  rpcRateLimited: "网络拥堵（RPC 429）",
  rpcRateLimitedDesc: "钱包使用的 RPC 节点被限流了。已自动切换到备用节点，请重试一次。资产没有发生链上变动。",
  pendingSignatureTip: "本次提现授权在几分钟内仍然有效，点「重试发送」会复用它，不会重复锁定额度。",
  retrySend: "重试发送",
  withdrawUnlocked: "本次提现没有上链，锁定的额度已解锁。",
  withdrawUnlockFailed: "暂时无法解锁，额度会在几分钟后自动释放。",

  // 可用资金（所有投资环节都必须显示，避免用户不知道最多能投多少）
  availableInContract: "合约内可用资金",
  max: "全部",
  shares: "份额",
  positionValue: "当前市值",
  potentialPayout: "可兑奖金",

  // 平台动态（Activity）
  activity: "动态",
  activityTitle: "平台动态",
  activitySubtitle: "全站所有产品、所有用户的参与记录，每 3 秒自动刷新。",
  activityLive: "实时",
  activityAllBoards: "全部",
  activityFilteredBy: "按钱包筛选",
  activityClearFilter: "清除",
  activityColMarket: "产品",
  activityColUser: "参与者",
  activityColOption: "选项",
  activityColAmount: "金额",
  activityColTime: "时间",
  activityEmpty: "暂无动态",
  activityEmptyHint: "有人下单后，参与记录会实时出现在这里。",
  activityTotal: "共 {n} 条参与记录",
  activityLoadMore: "加载更多",
  activityEnd: "已经看完啦",
  activityJustNow: "刚刚",
  activitySecondsAgo: "{n} 秒前",
  activityMinutesAgo: "{n} 分钟前",
  activityHoursAgo: "{n} 小时前",
  activityDaysAgo: "{n} 天前",
  walletBalance: "钱包余额",
  collect: "领取",
  approve: "授权",
  ticket: "许可证",
  category: "分类",
  sortBy: "排序",
  issue: "发行",
  confirm: "确认",
  detail: "详情",
  stakingType: "抵押",
  stakingTypeInfo: "为防止发行方恶意确认结果，请质押代币或当前NFT。",
  subscriptionAmount: "认购金额",
  subscription: "认购",
  subscribe: "购买",
  max: "最大",
  marketClosed: "市场已关闭",
  add: "增加",
  deposit: "充值",
  verifiedNFT: "查看已验证许可证",
  select: "选择",
  selected: "已选择",
  moreNFT: "获取更多许可证",
  forecastEvent: '事件',
  subscribeEndDate: '最后交易日',
  specifyLastTradingDate: "设置最后交易时间",
  specifyExpiryDate: '设置到期日期',
  endDate: '结束日期',
  validityPeriod: '到期日期',
  marketEndDate: '到期日期',
  liquidityMin: '最小流动性',
  premiumMin: "最低保费",
  paymentCurrency: "支付货币",
  defaultOdds: "默认杠杆",
  setDefaultOdds: "设置杠杆",
  minInvestAmout: "设置最低投资额",
  depositMargin: "添加流动性",
  totalPayment: "支付总额",
  rewards: "奖励",
  rewardRate: "奖励率",
  release: "释放",
  fee: "费用",
  marginFeeRate: "费率",
  cdsInfoOne: "发行预测产品时，需要质押保证金，设置默认杠杆和最低投资额。",
  cdsInfoTwo: "未参与的保证金可随时提取。",
  cdsInfoThree: "若超过1位用户选择对判定结果提出申诉，将启动社区治理机制以确定预测事件是否发生。",
  deposited: "已投入",
  issued: "已发行",
  depositedCDS: "已投资产品",
  totalProfit: "总收益",
  allOrDeposited: "总计/已投入",
  rewardsOrProfit: "奖励/收益",
  estimatedInvested: "预计/已投入",
  profit: "收益",
  yesterdayProfit: "昨日收益",
  status: "状态",
  eventConfirming: "事件确认中",
  appeal: "申诉",
  appealing: "申诉中",
  appealFailed: "申诉失败",
  occured: "已发生",
  notOccured: "未发生",
  governanceMechanism: "当申诉人数超过一人时，启动社区治理机制。",
  appealLimit: "申诉人数不超过一人。",
  waitResult: "等待申诉结果",
  frozenMargin: "冻结保证金",
  marginBalance: "保证金余额",
  balance: "余额",
  cash: '现金',
  createNew: '创建市场',
  withdraw: "提取",
  endTime: "距结束倒计时",
  guaranteeing: "进行中",
  guaranteeingEvent: "预测进行中",
  confirmsEventAdvance: "事件提前确认发生。",
  waitConfirmation: "事件等待确认。",
  triggerEvent: "事件已确认发生。",
  notTriggerEvent: "事件未发生。",
  defaultChallenging: "事件已发生，申诉中。",
  notDefaultChallenging: "事件未发生，申诉中。",
  defaultChallengeFailed: "事件已发生，申诉失败。",
  notDefaultChallengeFailed: "事件未发生，申诉失败。",
  defaultWaitingResult: "事件已发生，等待治理结果。",
  notDefaultWaitingResult: "事件未发生，等待治理结果。",
  defaultGovernanceMechanism: "治理机制确认事件已发生。",
  notDefaultGovernanceMechanism: "治理机制确认事件未发生。",
  cancel: "取消",
  defaultAhead: "提前发生",
  occur: "已发生",
  notOccur: "未发生",
  stakingToChallenge: "质押以申诉",
  challenged: "已申诉",
  checking: "审核中",
  fail: "失败",

  appealInfoOne: "如果你认为当前预测事件的判定与事实不符，可以“申诉”，启动治理机制以最终确定当前预测结果。",
  check: "查看",
  contentIllegal: "预测事件包含不合规内容，请修改后再发行",
  subscribed: "已投资产品",
  receivingCompensation: "待领取",
  received: "总赔付",
  receive: "领取",
  compensationAmount: "已发生赔付金额",
  liquidity: "流动性",
  injectLiquidity: "注入流动性",
  uRLContent: "链接/内容",
  resolutionSource: "判定来源",
  textareaInfo: "请简要描述该事件。",

  // Issue.vue 通知文案（顶层）
  issueMsgPleaseSelectLicense: "请选择许可证",
  issueMsgLicenseCannotBeStaked: "许可证不可质押",
  issueMsgNetworkNotConnected: "网络未连接",
  issueMsgEventEmpty: "事件内容为空",
  issueMsgSelectLicense: "请选择许可证",
  issueMsgLastTradingDateEmpty: "最后交易日为空",
  issueMsgExpirationDateEmpty: "到期日期为空",
  issueMsgOptionsEmpty: "选项不能为空",
  issueMsgOptionsLessThanTwo: "选项不能少于两个",
  issueMsgOptionEmpty: "选项内容不能为空",
  issueMsgOptionRepeated: "选项内容不能重复",
  issueMsgLiquidityInvalid: "流动性参数 b 必须大于 0",
  issueMsgOddsInvalid: "赔率必须在 1.01 ~ 100 之间",
  fixedOddsProductHint: "赔率是产品级的：由你在发起时设定一个整数倍数（如 100 = 投 1 中 100），与 Yes / No 选项无关，任一选项获胜都按同一赔率兑付。",
  issueMsgCapacityInvalid: "额度必须大于等于 0",
  optionsMultiHint: "（默认 2 项，多结果事件可继续增加）",
  dynamicLiquidity: "流动性参数 b",
  dynamicLiquidityHint: "b 越大盘口越深、单笔滑点越小。1000 适合几十到几百量级的参与。",
  fixedOddsBookmakerHint: "在这个板块里你是庄家：你放在每个选项上的资金，就是对手方获胜时赔付的来源。请填写你愿意兑现的赔率，以及每一侧你能承担的最大负债。",
  issueMsgLastTradingDateGreaterThanToday: "最后交易日必须大于今天",
  issueMsgLastTradingDateGreaterThanExpirationDate: "最后交易日大于到期日",
  issueMsgLicenseError: "许可证错误",
  issueMsgTicketError: "凭证错误",
  issueMsgEventEndDateGreaterThanRentalEndDate: "事件结束日期 {eventEndDate} 晚于租赁结束日期 {rentalEndDate}",
  issueMsgInsufficientBalance: "余额不足",
  issueMsgTransactionFailed: "交易失败",
  issueMsgIssueSuccess: "发行成功",
  issueMsgTransactionCancelled: "交易已取消",

  donations: "捐赠",
  amount: "数量",

  short: {
    confirmsEventAdvance: "提前发生",
    waitConfirmation: "等待确认",
    defaultChallenging: "发生-申诉中",
    notDefaultChallenging: "未发生-申诉中",
    defaultChallengeFailed: "发生-申诉失败",
    notDefaultChallengeFailed: "未发生-申诉失败",
    defaultWaitingResult: "发生-治理中",
    notDefaultWaitingResult: "未发生-治理中",
    defaultGovernanceMechanism: "发生-治理确认",
    notDefaultGovernanceMechanism: "未发生-治理确认"
  },

  wallet: {
      openWallet: "打开钱包",
      connectWallet: "连接钱包",
      connectingWallet: '连接中',
      connectYourWallet: "连接钱包",
      disconnect: "断开连接",
      wrongNetwork: "网络错误"
  },
	
  NFT: {
    inputSearchText: "请输入搜索内容",
    donations: "捐赠",
    amount: "金额",
    description: "描述",
    getPrediLicense: "获取 Predi 许可证",
    referralRewards: "邀请奖励",
    mintYourLicence: "铸造你的许可证",
    usageRights: "使用权",
    issuePredictionProducts: "发行预测产品",
    governance: "治理",
    properties: "属性",
    tradable: "可交易",
    rentable: "可租赁",
    usable: "可使用",
    marketsToIssue: "可发行市场",
    times: "次",
    availableTimes: "可用次数",
    ticketId: "许可证编号",
    cancelRentHint: "该许可证正在出租，请先取消后再出售。",
    seeMore: "查看更多",
    sell: "出售",
    rent: "出租",
    // 新增：NFT 详情页用到的文案
    rules: "规则",
    payoff: "收益",
    details: "详情",
    licenseOwner: "许可证持有者",
    tokenId: "Token ID",
    getYourLicense: "获取你的许可证",
    issueTimesList: "发行次数列表",
    total: "总计",
    time: "时间",
    user: "用户",
    expiringDate: "到期日期",
    period: "期限",
    days: "天",
    unsold: "未售出",
    onSale: "NFT 正在出售。",
    licenseSaleRentable: "当前许可证可出售或出租。",
    licenseCanSell: "许可证可出售。",
    licenseUnsold: "许可证未出售。",
    selling: "出售中",
    pleaseInputValidPrice: "请输入有效价格",
    tabGetLicense: "获取许可证",
    issueTip: "每个许可证可发行10个预测产品",
    tabMyLicense: "我的许可证",
    tabMarket: "市场",
    marketDisabled: '二级市场暂未开放。',
    price: "价格",
    prediLicense: "Predi 许可证",
    common: "普通",
    scarcity: "稀有",
    attributive: "属性",
    numbers: "发行数量",
    success: "成功",
    getNFT: "获取许可证成功",
    issueCDS: "发行 Predi 市场",
    buyNow: "立即购买",
    mintNow: "立即铸造",
    rule: "规则",
    comingSoon: "敬请期待！",
    type: "类型",
    from: "来自",
    to: "至",
    me: "我",
    rented: "已出租",
    sold: "已售出",
    bought: "已购买",
    boughtProducts: "已购买产品",
    investedProducts: "已投资产品",
    // ---- v1.9.7 i18n 补漏：组件引用但语言包缺失的 key（纯追加）----
    buy: "购买",
    sale: "出售",
    onRent: "出租中",
    rentDate: "租用日期",
    minimumDays: "最少天数",
    rentDateLessThanMinimum: "租用日期须大于最少天数",
    sellRule1: "设定价格后挂单出售，成交前许可证仍可使用。",
    sellRule2: "售出前，持有人可随时取消挂单。",
    rentRule1: "租用人在租期内可使用本许可证发行预测盘。",
    rentRule2: "出租前，持有人可随时取消挂单。",
    rentRule3: "租金以支付代币结算，持有人预先收取。",
    payoffDetails: "本许可证下发行的预测盘结算后，收益将计入你的余额。",
    transactionHistory: "交易历史",
    confirmCancel: "确定取消{type}？",
    pleaseInputValidRentDate: "请输入有效的租用日期",
    pleaseInputValidTimes: "请输入有效的次数",
    insufficientFunds: "资金不足",
    issuedProducts: "已发行产品"
  },
  // 顶层 claim（模板按 claim.* 引用）
  claim: {
    title: "免费领取 PRDs",
    subtitle: "轻松一点，获取你的 PRDs 代币",
    walletAddress: "钱包地址",
    status: "状态",
    connectWalletFirst: "请先连接钱包",
    eligibility: {
      claimed: "你已领取过空投",
      eligible: "你可以领取空投",
      error: "查询领取资格时出错"
    },
    button: {
      claim: "领取空投",
      alreadyClaimed: "已领取",
      connect: "连接"
    },
    footerNotice: "每个钱包仅可领取一次。请确保连接到正确的网络。",
    messages: {
      connectFirst: "请先连接钱包",
      claimSuccess: "领取空投成功！",
      claimFailed: "领取空投失败，请稍后重试",
      txCancelled: "交易已取消",
      onlyOnce: "每个用户仅可领取一次",
      insufficientBalance: "合约余额不足，请稍后重试"
    }
  },
  positions: "持仓",
  options: "选项",
  all: "全部",
  volume: "成交量",
  newest: "最新",
  pending: "待定",
  audit: "审核",
  loading: "加载中",
  home: "首页",
  market: "市场",
  markets: "市场",
  community: "社区",

  // 四个产品板块（PRD v1.1）：导航下拉 + 移动端页内 tab
  productType: "板块",
  // 板块名一律带「市场」后缀：导航下拉里只写"经典"对新用户毫无信息量
  typeClassic: "经典市场",
  typeDynamic: "动态市场",
  typeFixedOdds: "固定赔率市场",
  typePrice: "价格市场",
  zoneAll: "全部",
  zonePlatform: "平台盘",
  zonePartner: "合作区",
  // 可插拔模块状态（底座 + 业务模块）
  typePaused: "暂停中",
  typePausedHint: "该板块已暂停：可以继续浏览已有预测，但暂时不能发起或参与新的预测。",
  typeOffline: "即将上线",
  typeOfflineHint: "该板块尚未上线：导航保留板块名作为占位，开放之前不能进入。",
  // Price 板块（链下）
  priceAutoIssued: "平台自动发行",
  priceIssueHint: "价格预测由平台按周期自动发行，无需手动创建。请选择其它板块发起你自己的预测。",
  priceCurrent: "当前价格",
  priceIssuePrice: "发行价",
  priceSettlePrice: "结算价",
  pricePool: "奖池总额",
  priceJoin: "参与本轮",
  // v2.4.0 直投模式（direct）：钱包直接投入，合约内结算
  priceJoinDirect: "参与（钱包直接支付）",
  priceDirectHint: "直投模式：资金由钱包直接投入盘口合约，无需充值，结算在链上完成。单笔下限：",
  priceClaim: "领取",
  priceDirectMinAmount: "单笔不得低于",
  priceDirectNoDeposit: "直投模式没有站内托管余额：充值与提现不可用，奖金由合约直接打回钱包。",
  pricePositionsTitle: "价格持仓",
  priceOption: "选项",
  priceAmount: "投入",
  pricePayout: "派彩",

  // ---- Portfolio 一级页签 + 资金/奖励中心（v1.2 §5/§6）----
  portfolioTabPositions: "持仓",
  portfolioTabFunds: "资金",
  portfolioTabRewards: "奖励",
  fundsAvailable: "可用余额",
  fundsLocked: "占用中",
  fundsOpenCost: "未结算成本",
  fundsMarketValue: "当前估值",
  fundsUnrealized: "未实现盈亏",
  fundsRealized: "已实现盈亏",
  fundsFeesPaid: "累计费用",
  fundsReferralIncome: "推荐收入",
  fundsValuationNote: "说明：动态市场按 LMSR 现价估值，其余板块按成本计价；未实现盈亏在结算前不算已实现收益。",
  fundsActivity: "交易明细",
  fundsSettlements: "结算收益",
  fundsAllActions: "全部动作",
  fundsAllStatus: "全部状态",
  fundsAllSources: "全部来源",
  fundsColTime: "时间",
  boardName: "板块",
  fundsColAction: "动作",
  fundsColPrincipal: "本金",
  fundsColEntryFee: "买入费",
  fundsColExitFee: "退出费",
  fundsColSettleFee: "结算费",
  fundsColNetCash: "净现金流",
  fundsColRealized: "已实现",
  fundsColRefund: "退款",
  actBuy: "买入",
  actChallenge: "下注",
  actIssueIncome: "发行收入",
  actPayout: "派彩",
  actRefund: "退款",
  actReferral: "推荐奖励",
  actVipReward: "VIP 奖励",
  actFirstInvest: "首投奖励",
  actRiskCapital: "风险资金",
  actMakerIncome: "做市收入",
  actFaucet: "测试币领取",
  actTransferOut: "转出",
  actTransferIn: "转入",
  rewardTotal: "累计奖励",
  rewardPending: "待确认",
  rewardConfirmed: "已确认",
  rewardPaid: "已发放",
  rewardReversed: "已撤销",
  rewardClaimable: "可领取",
  rewardNote: "奖励来自入场费/退出费/结算收入/平台净收入分成与促销预算；撤销的奖励保留原记录并带冲正流水，绝不删除历史。",
  rewardColSource: "来源",
  rewardColInvitee: "被推荐人",
  rewardColLevel: "层级",
  rewardColRate: "比例",
  rewardColAmount: "金额",
  rewardColConfirmAt: "预计确认",
  rewardStatusPending: "待确认",
  rewardStatusConfirmed: "已确认",
  rewardStatusPaid: "已发放",
  rewardStatusFrozen: "已冻结",
  rewardStatusReversed: "已撤销",
  rewardSrcEntryFee: "入场费分成",
  rewardSrcExitFee: "退出费分成",
  rewardSrcSettlement: "结算收入分成",
  rewardSrcPlatformNet: "平台净收入分成",
  rewardSrcPromotion: "促销预算",
  typeEmptyTitle: "即将开放",
  typeEmptyHint: "可以先回到「经典」板块查看正在进行的预测。",
  typeDescClassic: "经典市场是最早的预测形式：选中正确选项的人，按各自投入比例瓜分奖池。",
  typeDescDynamic: "动态市场像交易份额一样买卖结果：价格由 AMM 自动定价，结算前随时可买可卖，价格始终反映大家认为的概率。",
  typeDescFixedOdds: "固定赔率市场由发起人坐庄：他提供资金并挂出赔率，你按提前锁定的赔付与他做对手方。",
  typeDescPrice: "价格市场按白名单行情源自动判定：选择小时/天/周周期，判断 BTC、ETH 等标的的涨跌。",
  // Dynamic / Fixed-Odds 参与面板
  dynamicMarket: "动态市场",
  fixedOddsMarket: "固定赔率市场",
  shares: "份额",
  capacityLeft: "剩余额度",
  capacity: "额度",
  bookmaker: "庄家",
  marketPool: "奖池",
  totalStaked: "累计注金",
  riskCapital: "风险资金",
  // ---- Fixed-Odds 用户注单提前退出（v1.9.16）----
  issuerNoExitHint: "发起人本人不能退出额度——注入的风险资金将锁定至产品结算。",
  myFixedOddsBets: "我的注单",
  earlyExitBtn: "提前退出",
  earlyExitTitle: "提前退出报价",
  exitProgress: "产品周期进度",
  exitStake: "注单本金",
  exitValuationDeduction: "估值折扣",
  exitServiceFeeBps: "平台服务费",
  exitGraceTag: "免责窗口",
  exitGraceNote: "免责窗口内退出只收平台服务费。",
  userExitDone: "注单已提前退出",
  riskCapitalManage: "风险资金管理",
  riskCapitalHint: "你是本盘的对手方。注入的资金会被占用，用于覆盖你尚未结清的赔付义务；提前取出要付退出费，且取出后剩余资金仍须足够偿付。",
  riskCapitalInject: "注入风险资金",
  riskCapitalInjectBtn: "注入",
  riskCapitalInjected: "风险资金已注入",
  riskCapitalExit: "提前取出（收取退出费）",
  riskCapitalExitBtn: "取出",
  riskCapitalExited: "风险资金已取出",
  exitFee: "退出费",
  exitMakerShare: "你做市商的分成",
  exitPlatformShare: "平台分成",
  exitNet: "实际到账",
  exitSolvencyBlock: "取这么多会让剩余风险资金低于你尚未结清的赔付义务，已被拦截。",
  estimatedCost: "预计成本",
  estProceeds: "预计回收",
  boardFee: "手续费",
  boardFeeFree: "免手续费",
  boardFeeStage: "时间系数",
  boardFeeRate: "费率",
  boardSlippageExceeded: "价格变动已超过你的滑点上限，请按最新报价重新确认。",
  boardQuoteExpired: "报价已过期，请按最新价格重新确认。",
  boardQuoteStale: "报价后费率规则已变更，请按最新费率重新确认。",
  potentialPayout: "潜在赔付",
  bet: "下注",
  betOdds: "赔率",
  sortVolume: "交易量",
  sortNewest: "最新发布",
  sortEndingSoon: "即将结束",
  priceKlineEmpty: "暂无走势数据",
  value: "市值",
  boardSettled: "已结算",
  noProducts: "暂无预测产品",
  noProductsDesc: "当前筛选条件下还没有进行中的预测，换个分类或稍后再来看看。",
  deposit: "充值",
  bridge: "跨链",
  portfolio: "投资组合",
  language: '语言',
  empowering: "赋能引领者，预测未来",
  myPositions: "我的持仓",
  challengeCredit: "申诉信用",
  challengeStatus: "申诉状态",
  succeed: "成功",
  wait: "等待",
  return: "返回",
  createYourOwnMarket: "创建你的市场",
  waitChallenge: "事件等待申诉。",
  complaintCountdown: "申诉倒计时",
  setResult: "设置结果",
  insufficientFunds: "资金不足",
  buyTicket: "购买许可证",
  buy: "购买",
  listYourToken: "上架你的代币",
  description: "描述",
  setResultModalTitle: "设置结果：",
  cancelModalTitle: "取消",
  cancelIrreversible: "取消不可逆。",
  challengeModalTitle: "申诉",
  challengeStakeIntro: "若事实存在偏差，将返还给你。",
  challengeStakeButton: "使用 PRDS 发起申诉",
  history: "历史",
  waitingGovernanceResult: "事件等待治理机制结果。",
  eventFinished: "事件已结束。",
  predictionToken: "预测代币",
  issuerResult: "发行方结果",
  daoResult: "DAO 结果",
  licenses: "许可证",
  prediLicense: "Predi 许可证",
  issuableQuantity: "可发行数量",
  disabled: "不可用",
  battleImage: "佐证图片",
  upload: "上传",
  showSample: "查看示例",
  battleInformation: "争议佐证",
  baseToken: "基础代币",
  collateral: "抵押",
  currentLicense: "当前许可证",
  predictionProject: "预测项目：",
  issueExpireIntro: '在到期时间，选择正确选项的人将根据其参与份额瓜分产品池中的代币。',
  issueParticipateUntil: "用户可参与该产品直到",
  issueConfirmAdvance: '如果事件在到期时间前发生，发行方可提前确认结果。',
  issueChallengeWithin7Days: "如果参与者对发行方确认的事件结果有异议，可在确认后的7天内点击“申诉”。",
  // ---- 详情页 Description：四大板块各自的机制模板（字段/玩法不同，不能共用一套文案）----
  descDynamicWhat: '这是一个动态预测盘：结果被做成份额来交易，价格随每一笔买卖实时变动，和 Polymarket 一样。',
  descDynamicPrice: '每个选项都有一个 0~1 之间的实时价格，这个价格就是市场认为它获胜的概率；所有选项的价格之和恒为 1。',
  descDynamicLiquidity: '价格由自动做市商（LMSR）定价，本盘的流动性参数 b 为',
  descDynamicTrade: '收盘前随时可以买入或卖出份额：买入推高该选项价格、卖出压低；仓位也可以提前平掉退出。',
  descDynamicSettle: '事件结算时，获胜选项的每一份份额兑付 1 个计价资产，落败选项的份额归零。',
  descFixedWhat: '这是一个固定赔率盘：发起人作为庄家在每一笔注单的另一侧提供资金，你按提前锁定的赔率与他做对手方。',
  descFixedBookmaker: '因为资金由发起人提供，你的赔付由他公布的额度担保——下注之前就知道确切回报。',
  descFixedExample: '例：发起人把 100 万资金放在「不会加息」一侧，赔率 5 倍。你若在「会加息」一侧下注 100，一旦真的加息即可拿回 500；如果没有发生，这 100 全归发起人。',
  descFixedOdds: '本盘当前各选项赔率：',
  descFixedSettle: '结算时，押中的注单按「注金 × 下注时锁定的赔率」赔付，押错的注金归发起人；注单成交后赔率不再变动。',
  descPriceWhat: '这是一个价格预测盘：判断某个交易对在固定时间窗口内的涨跌方向，只有「涨 / 跌」两个结果。',
  descPriceBase: '本盘发行时记录的基准价为',
  descPriceSettle: '到期时结算价由白名单行情源自动取得：结算价高于基准价则「涨」获胜，否则「跌」获胜；获胜者按投入比例瓜分奖池。',
  issueAttention: "注意：Predi 致力于促进娱乐与社交体验。本平台严禁任何形式的赌博相关活动。",
  eventSampleTitle: "事件",
  // 示例刻意覆盖多选项场景（竞选 / 联赛排名 / 选美 / 区间），不要再全用 yes/no
  issueSampleElection: "下一届全国总统大选谁会胜出？",
  issueSampleElectionOpts: "候选人甲 / 候选人乙 / 候选人丙 / 候选人丁 / 尚未定局",
  issueSampleLeague: "本赛季哪个俱乐部夺得联赛冠军？",
  issueSampleLeagueOpts: "阿森纳 / 利物浦 / 曼城 / 切尔西 / 热刺 / 纽卡斯尔",
  issueSamplePageant: "今年国际选美大赛的冠军是谁？",
  issueSamplePageantOpts: "选手甲 / 选手乙 / 选手丙 / 选手丁 / 选手戊",
  issueSampleCrypto: "今年年底 BTC 会收在哪个区间？",
  issueSampleCryptoOpts: "15 万以上 / 12~15 万 / 9~12 万 / 9 万以下",
  issueSampleTech: "哪家公司先推出主流 AR 眼镜？",
  issueSampleTechOpts: "苹果 / Meta / 三星 / 谷歌 / 其它",
  issueSampleBinary: "美联储下次会议会降息吗？",
  issueSampleBinaryOpts: "会 / 不会（二元问题用两个选项就够了）",
  issueSampleMultiTip: "选项是自由填写的：二元问题用两个，竞选、联赛排名、选美这类可以尽情加。默认两项，不够就继续点「增加」。",
  predictionToken: "预测代币",
  license: "许可证",
  issuer: "发行方",
  issuerProfit: "发行方收益",
  recycleTicket: "回收许可证",
  eventCancelled: "事件已取消。",
  challenge: "申诉",
  share: "分享",
  // ---- v1.9.7 i18n 补漏：组件引用但语言包缺失的 key（纯追加）----
  go: "前往",
  noData: "暂无数据",
  linkCopied: "链接已复制",
  linkCopyFailed: "复制链接失败",
  pleaseSelectOption: "请选择选项",
  subscribeSuccess: "订阅成功",
  transactionCancelled: "交易已取消",
  transactionFailed: "交易失败",
  transactionSuccess: "交易成功",
  bought: "已购买",
  boughtProducts: "已购买产品",
  sell: "出售",
  cancelled: "已取消",
  auditChecking: "审核中",
  comingSoon: "敬请期待！",
  from: "来自",
  to: "至",
  me: "我",
  investedProducts: "已投资产品",
  issuedProducts: "已发行产品",
  predictionProduct: "预测产品",
  price: "价格",
  type: "类型",
  inputSearchText: "请输入搜索内容",
  theme: "主题",
  USDT: "USDT",

  USDT: "USDT"

}
